import { findNativeApp } from 'utils/findNativeApp';

import {
  PROTECT_NATIVE_APP_ID,
  VIDEO_NATIVE_APP_ID,
} from '../../partnerCenterApp/constants/native-apps';

export type TokenScopeOrg = Utils.DeepNonUndefined<
  Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >['org']
>;

export const getVideoOnlyCustomerRedirectUrl = (org?: TokenScopeOrg) => {
  if (!org) return;

  // A video only customer should go to Aware immediately
  const videoNativeApp = findNativeApp(org.orgNativeApps, VIDEO_NATIVE_APP_ID);
  const protectNativeApp = findNativeApp(
    org.orgNativeApps,
    PROTECT_NATIVE_APP_ID,
  );

  // Protect is considered video use any of the urls with the order here being the preference
  return videoNativeApp?.url || protectNativeApp?.url;
};
